import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportComputedCredit from '@/pages/report-computed-credit/ReportComputedCredit'

export default {
  path: '/report-billing',
  name: 'BillingReport',
  components: {
    mainContent: ReportComputedCredit,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-computed-credit'
    },
    breadcrumb: {
      title: 'Relatórios de Faturamento',
      paths: [
        { title: 'Relatório' },
        { title: 'Relatório de Faturamento' }
      ]
    }
  }
}